export default {
  questionType: {
    text: '文本',
    date: '日期',
    single: '单选',
    multiple: '多选',
    attachment: '附件',
    link: '协议超链接',
    location: '所在地',
    country: '国家/地区',
    province: '省份',
    city: '城市',
    nationality: '国籍',
    language: '语言',
    nps: '净推荐值',
    stars: '六分制问题',
    repeatGroup: '可重复字段组',
    dateRange: '日期范围'
  },
  prefillSource: {
    none: '不预填',
    candidateName: '候选人姓名',
    candidateMobile: '候选人手机',
    candidateEmail: '候选人邮箱',
    jobTitle: '职位名称',
    resumeEducation: '简历教育经历',
    resumeWork: '简历工作经历'
  }
}
